@if (isDebtConsolidationEnabled() && shouldShow) {
<div class="bg-white mb-5 rounded-xl">
  <img
    src="assets/images/debt-consolidation.png"
    alt=""
    class="w-full block rounded-t-xl"
  />
  <div class="p-6">
    <h3 class="app-card-title">
      You could be eligible for smarter debt solutions
    </h3>
    <p class="mt-2 app-card-text mb-5">
      We'll show you how much you could save by refinancing or consolidating your debt.
    </p>
    <a
      [href]="url"
      target="_blank"
      rel="noopener noreferrer"
      (click)="fireLinkClickEvent()"
      class="be-btn be-btn--small be-btn--ghost no-underline"
    >
      See your results
    </a>
  </div>
</div>

}
